// @flow
import React, { Component } from "react"
import Link from "gatsby-link"
import { Motion, spring } from "react-motion"
import { rhythm } from "../utils/typography"
import { greyXLight, primaryLight, primary, primaryDark } from "../utils/colors"

type State = {
  hovering: boolean,
  loading: boolean,
}

type Props = {
  target: string,
  icon: string,
  title: string,
  description: string,
}

class FeatureGalleryItem extends Component<Props, State> {
  constructor() {
    super()
  }

  state = {
    hovering: false,
    loading: true,
  }

  animations = {}

  componentDidMount() {
    this.setState({
      loading: false,
    })
  }

  whenMouseEntered = () => {
    this.setState({ hovering: true })
  }

  whenMouseLeft = () => {
    this.setState({ hovering: false })
  }

  renderTopState() {
    return (
      <div css={styles.topContent}>
        <div>
          <div css={styles.icon}>
            <img src={this.props.icon} />
          </div>
          <h5 css={styles.title}>{this.props.title}</h5>
        </div>
      </div>
    )
  }

  renderUnderneathState(x: number) {
    return (
      <div
        css={styles.bottomContent}
        style={{
          WebkitTransform: `translateY(${x}%)`,
          transform: `translateY(${x}%)`,
        }}
      >
        <h5 css={styles.title}>{this.props.title}</h5>
        <p css={styles.description}>{this.props.description}</p>
        <span css={styles.cta}>Learn More</span>
      </div>
    )
  }

  render() {
    return (
      <div css={styles.wrapper}>
        <Link
          to={this.props.target}
          css={styles.inner}
          onMouseEnter={this.whenMouseEntered}
          onMouseLeave={this.whenMouseLeft}
        >
          {this.renderTopState()}
          <Motion
            style={{
              x: spring(this.state.hovering ? 0 : 100, {
                stiffness: 250,
                damping: 20,
              }),
            }}
          >
            {({ x }) => this.renderUnderneathState(x)}
          </Motion>
        </Link>
      </div>
    )
  }
}

const styles = {
  wrapper: {
    flex: "1",
    minWidth: "20.25em",
    maxWidth: "33%",
    padding: rhythm(),
  },
  inner: {
    position: "relative",
    overflow: "hidden",
    display: "block",
    width: "100%",
    color: primaryDark,
    textDecoration: "none",
    textAlign: "center",
    border: "1px solid rgba(0, 0, 0, 0.11)",
    borderRadius: "5px",
    boxShadow: "0 0 0 0 rbga(0,0,0,0)",
    transition: "all 0.3s ease",
    "&:hover": {
      transform: "translateY(-3px)",
      boxShadow: "4px 4px 24px 4px rgba(0, 0, 0, 0.08)",
    },
    "> :last-child": {
      marginBottom: "0",
    },
  },
  topContent: {
    position: "absolute",
    top: "0",
    right: "0",
    bottom: "0",
    left: "0",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: rhythm(3 / 2),
  },
  bottomContent: {
    display: "flex",
    flexDirection: "column",
    minHeight: "16.5em",
    padding: rhythm(3 / 2),
    backgroundColor: primaryLight,
    position: "relative",
    "&:after": {
      // Fill below to account for animation damping
      content: "' '",
      display: "block",
      backgroundColor: primaryLight,
      width: "100%",
      left: "0",
      right: "0",
      height: rhythm(2),
      position: "absolute",
      bottom: `-${rhythm(2)}`,
    },
  },
  icon: {
    backgroundColor: greyXLight,
    height: "5.875em",
    width: "5.875em",
    borderRadius: "3em",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    margin: `0 auto ${rhythm()} auto`,
    "> img": {
      marginBottom: 0,
    },
  },
  title: {
    marginBottom: 0,
  },
  description: {
    margin: `${rhythm()} auto`,
  },
  cta: {
    color: primary,
    fontWeight: 600,
    textTransform: "uppercase",
    marginTop: "auto",
  },
}

export default FeatureGalleryItem



// WEBPACK FOOTER //
// ./src/components/FeatureGalleryItem.js